export const SDK_VERSION = '8.22.0';
